import './types.js'
import { getAppMaster } from '../../../common/utils/DynamoDbUtils'

/**
 * @param {string[]} files
 * @param {string} permissionKey
 * @returns {string[]}
 */
export function toggleGenericDataKindInFilesList(files, permissionKey) {
  if (files.includes(permissionKey)) {
    return files.filter((node) => node !== permissionKey)
  }
  return [...files, permissionKey]
}

/**
 * AppMaster GenericDataKind を取得し camelCase に正規化する
 *
 * @param {string} corporationNumber
 * @returns {Promise<import('./types.js').GenericDataKindItem[]>}
 */
export async function fetchGenericDataKinds(corporationNumber) {
  try {
    const data = await getAppMaster(corporationNumber, { ConfigName: 'GenericDataKind' }, null)
    if (!data || !Array.isArray(data)) {
      return []
    }
    return data
      .map((item) => {
        const genericDataKindCode = item.GenericDataKindCode ?? item.genericDataKindCode ?? ''
        const genericDataKindName = item.GenericDataKindName ?? item.genericDataKindName ?? ''
        const genericDataSuperKindCode = item.GenericDataSuperKindCode ?? item.genericDataSuperKindCode ?? ''
        if (!genericDataKindCode || !genericDataSuperKindCode) {
          return null
        }
        return {
          genericDataKindCode: String(genericDataKindCode),
          genericDataKindName: String(genericDataKindName),
          genericDataSuperKindCode: String(genericDataSuperKindCode)
        }
      })
      .filter(Boolean)
  } catch (error) {
    console.error('fetchGenericDataKinds:', error)
    return []
  }
}

/**
 * AppMaster GenericDataSuperKind を取得し camelCase に正規化する
 *
 * @param {string} corporationNumber
 * @returns {Promise<import('./types.js').GenericSuperKindItem[]>}
 */
export async function fetchGenericSuperKinds(corporationNumber) {
  try {
    const data = await getAppMaster(corporationNumber, { ConfigName: 'GenericDataSuperKind' }, null)
    if (!data || !Array.isArray(data)) {
      return []
    }
    return data
      .map((item) => {
        const genericDataSuperKindCode = item.GenericDataSuperKindCode ?? item.genericDataSuperKindCode ?? ''
        const genericDataSuperKindName = item.GenericDataSuperKindName ?? item.genericDataSuperKindName ?? ''
        if (!genericDataSuperKindCode) {
          return null
        }
        return {
          genericDataSuperKindCode: String(genericDataSuperKindCode),
          genericDataSuperKindName: String(genericDataSuperKindName)
        }
      })
      .filter(Boolean)
  } catch (error) {
    console.error('fetchGenericSuperKinds:', error)
    return []
  }
}
